module.exports = __webpack_public_path__ + "img/liveClassFeature2.4d557fd.svg";